import React from 'react';
import './Footer.css';
import logoImg from '../purayida-krishi-logo-malayalam.png';

const Footer = ({ language }) => {
  const handleFooterNav = (e, sectionId) => {
    e.preventDefault();
    const scrollToSection = () => {
      const el = document.getElementById(sectionId);
      if (el) {
        const topAdHeight = window.innerHeight * 0.1; // 10vh
        const headerHeight = 80; // approximate header height
        const offset = topAdHeight + headerHeight + 20; // +20px padding
        const elementPosition = el.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - offset;
        window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
      }
    };
    if (window.location.hash && window.location.hash !== '#' && !window.location.hash.startsWith('#' + sectionId)) {
      window.location.hash = '#';
      setTimeout(scrollToSection, 100);
    } else {
      scrollToSection();
    }
  };

  return (
    <footer className="footer">
      <div className="container footer-grid">
        <div>
          {/* Main brand logo with corner logo inside */}
          <div className="footer-brand">
            {/* Corner logo at top center of brand */}
            <div className="footer-corner-logo">
              <img src="/purayida-krishi-logo--white.png" alt="Purayidakrishi" className="footer-corner-logo-img" />
            </div>
            <img src={logoImg} alt="Purayidakrishi" className="footer-brand-logo" />
          </div>
          <p>
            {language === 'en' 
              ? 'Homestead agroecology for healthy homes and healthy soil.'
              : 'ആരോഗ്യകരമായ മണ്ണിനും കുടുംബത്തിനുമായി സ്വാഭാവിക വീട്ടുതോട്ടം.'}
          </p>
        </div>

        <div className="footer-col center footer-links-col">
          <h4>{language === 'en' ? 'Quick Links' : 'ക്വിക്ക് ലിങ്കുകള്‍'}</h4>
          <ul className="footer-links">
            <li><a href="#home" onClick={(e) => handleFooterNav(e, 'home')}>{language === 'en' ? 'Home' : 'ഹോം'}</a></li>
            <li><a href="#mystory" onClick={(e) => handleFooterNav(e, 'mystory')}>{language === 'en' ? 'My Story' : 'എന്റെ കഥ'}</a></li>
            <li><a href="#services" onClick={(e) => handleFooterNav(e, 'services')}>{language === 'en' ? 'Services' : 'സേവനങ്ങൾ'}</a></li>
            <li><a href="#blog" onClick={(e) => handleFooterNav(e, 'blog')}>{language === 'en' ? 'Blog' : 'ബ്ലോഗ്'}</a></li>
            <li><a href="#book-store" onClick={(e) => handleFooterNav(e, 'book-store')}>{language === 'en' ? 'Book Store' : 'പുസ്തക സ്റ്റോർ'}</a></li>
            <li><a href="#gallery" onClick={(e) => handleFooterNav(e, 'gallery')}>{language === 'en' ? 'Gallery' : 'ഗാലറി'}</a></li>
            <li><a href="#faq" onClick={(e) => handleFooterNav(e, 'faq')}>{language === 'en' ? 'FAQ' : 'ചോദ്യോത്തരങ്ങൾ'}</a></li>
            <li><a href="#contact" onClick={(e) => handleFooterNav(e, 'contact')}>{language === 'en' ? 'Contact' : 'ബന്ധപ്പെടുക'}</a></li>
          </ul>
        </div>

        <div className="footer-col center">
          <h4>{language === 'en' ? 'Contact' : 'ബന്ധപ്പെടുക'}</h4>
          <ul className="footer-contact">
            <li className="contact-item">
              <strong>{language === 'en' ? 'Mail' : 'മെയിൽ'}:</strong>
              &nbsp;<a href="mailto:info@purayidakrishi.com">info@purayidakrishi.com</a>
            </li>
            <li className="contact-item">
              <strong>{language === 'en' ? 'Phone' : 'ഫോൺ'}:</strong>
              &nbsp;<a href="tel:+918138845709">8138845709</a>
            </li>
            <li className="contact-item">
              <strong>{language === 'en' ? 'Address' : 'വിലാസം'}:</strong>
              &nbsp;Parijatham, Paruthipra, Shoranur PO, Kerala, India 679121
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          <small>© {new Date().getFullYear()} Purayidakrishi. All rights reserved.</small>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
